import styles from './SkipLink.module.css';

function SkipLink({ ...props }) {
  // const { className, skipTo } = props;
  const onClick = (event) => {
    event.preventDefault();
    console.log('hit');
    const container = document.getElementById('mainContent');

    if (container) {
      container.tabIndex = -1;
      container.focus();
      setTimeout(() => container.removeAttribute('tabindex'), 1000);
    }
  };
  return (
    <button className={styles.skipLink} type="button" onClick={onClick}>
      Skip to main content
    </button>
  );
}

export default SkipLink;
